/**
 * Before/After Slider Functionality
 */

class BeforeAfterSlider {
  constructor(element) {
    this.slider = element;
    this.container = element.querySelector('.before-after-slider__container');
    this.beforeImage = element.querySelector('[data-before-image]');
    this.handle = element.querySelector('[data-slider-handle]');

    if (!this.container || !this.beforeImage || !this.handle) return;

    this.isDragging = false;
    this.containerRect = null;

    this.init();
  }

  init() {
    // Mouse events
    this.container.addEventListener('mousedown', (e) => this.startDrag(e));
    document.addEventListener('mousemove', (e) => this.onDrag(e));
    document.addEventListener('mouseup', () => this.endDrag());

    // Touch events
    this.container.addEventListener('touchstart', (e) => this.startDrag(e), { passive: false });
    document.addEventListener('touchmove', (e) => this.onDrag(e), { passive: false });
    document.addEventListener('touchend', () => this.endDrag());

    // Update on window resize
    window.addEventListener('resize', () => this.updateContainerRect());

    // Initial rect calculation
    this.updateContainerRect();
  }

  updateContainerRect() {
    this.containerRect = this.container.getBoundingClientRect();
  }

  startDrag(e) {
    this.isDragging = true;
    this.updateContainerRect();
    this.updatePosition(e);

    // Prevent text selection while dragging
    e.preventDefault();
  }

  onDrag(e) {
    if (!this.isDragging) return;

    e.preventDefault();
    this.updatePosition(e);
  }

  endDrag() {
    this.isDragging = false;
  }

  updatePosition(e) {
    if (!this.containerRect) return;

    // Get the X position relative to the container
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    let x = clientX - this.containerRect.left;

    // Clamp the value between 0 and container width
    x = Math.max(0, Math.min(x, this.containerRect.width));

    // Calculate percentage
    const percentage = (x / this.containerRect.width) * 100;

    // Update the before image clip path
    this.beforeImage.style.clipPath = `polygon(0 0, ${percentage}% 0, ${percentage}% 100%, 0 100%)`;

    // Update the handle position
    this.handle.style.left = `${percentage}%`;
  }
}

// Initialize all sliders on the page
document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('[data-before-after]');
  sliders.forEach(slider => new BeforeAfterSlider(slider));
});
